import React from 'react';
import './Servicios.css';

const Soluciones = () => {
  return (
      
    <div className="servicios-container">
      <h1>Nuestros Servicios</h1>
      <div className="servicios-lista">
        <div className="servicio">
          <h2>Implementación de Sage 200</h2>
          <p>Adaptamos el ERP a las necesidades de cada empresa, con planes de implementación personalizados y formación especializada.</p>
        </div>
        
        <div className="contacto-background">
      <img src="/images/Serviciosbackground.jpg" alt="Imagen de fondo de contacto" />
      </div>
        <div className="servicio">
          <h2>Desarrollos a medida en Sage 200</h2>
          <p>Creamos servicios específicos dentro de Sage 200 para optimizar procesos y mejorar su funcionalidad.</p>
        </div>

        <div className="servicio">
          <h2>Integración con aplicaciones web y móviles</h2>
          <p>Conectamos Sage 200 con desarrollos externos para ampliar su capacidad.</p>
        </div>

        <div className="servicio">
          <h2>Consultoría especializada</h2>
          <p>Asesoramiento en gestión de producción, proyectos y finanzas, asegurando un uso óptimo del ERP.</p>
        </div>

        <div className="servicio">
          <h2>Soporte y asistencia técnica</h2>
          <p>Servicio de centralita y ticketing para resolver dudas, incidencias y nuevas configuraciones.</p>
        </div>
      </div>
    </div>
  );
};

export default Soluciones;
